import { LoadingContainer } from 'components/loadingContainer'
import { useImageById } from 'hooks/user/useImage/useImageById'
import { ShowWithImages } from 'types/Show'

import { Container, ImageComponent, ImageContainer, StyledCard } from './showCardWizard.style'

interface Props {
    data: ShowWithImages
    onClick: (id: string) => void
    selected?: boolean
}

export const ShowCardWizard = ({ data, onClick, selected }: Props) => {
    const { data: imageData, isLoading, error } = useImageById(data.cover_image.toString())

    return (
        <Container onClick={() => onClick(data.show_id)}>
            <LoadingContainer isLoading={isLoading} error={error}>
                <StyledCard
                    selected={selected}
                    title={data.name}
                    header={
                        <ImageContainer>
                            <ImageComponent alt="Card" src={imageData?.image_url} />
                        </ImageContainer>
                    }
                    className="w-1rem"
                />
            </LoadingContainer>
        </Container>
    )
}
